import React from 'react';

import { BaseMotionTokenTable, type MotionTokenTableValue } from '../base-table';

const values: MotionTokenTableValue[] = [
	{
		tokenName: 'motion.keyframe.fade.in',
		useFor: 'Hover reveal',
		value: '0-100%',
	},
	{
		tokenName: 'motion.keyframe.fade.out',
		useFor: 'Hover exit',
		value: '100-0%',
	},
];

/**
 * __Fade interaction table__
 */
export const MotionFadeInteractionTable = (): React.JSX.Element => {
	return <BaseMotionTokenTable values={values} testId="motion-fade-table" />;
};
